import { FC, useRef } from 'react';
import { AllieButton, AllieItem, AllieList, AlliePopover, AllieText } from '../../../../components';
import { chevronDownOutline } from 'ionicons/icons';
import { OrderPauseButtonsActionsProps, OrderPauseButtonsProps } from '../ProductionOrder.types';
import { AlliePlayCircleIcon, AlliePlayIcon, AllieStopCircleIcon } from '../../../../styling/icons';
import { PopoverContent, StyledDescText } from '../ProductionOrder.styles';

const namespace = 'production-order';

export const OrderPauseButtons: FC<OrderPauseButtonsActionsProps & OrderPauseButtonsProps> = ({
  actions,
  closeOP,
  resumeOP,
  startOP,
  onClickClose,
  onClickResume,
  onClickStart,
}) => {
  const popoverRef = useRef<HTMLIonPopoverElement>(null);
  const handleClickPopover = (cb: () => void) => {
    if (popoverRef.current) {
      popoverRef.current.dismiss();
    }
    cb();
  };
  return (
    <>
      <AllieButton
        id="btn-actions"
        fill="outline"
        allieType="secondary"
        allieColor="neutral"
        allieSize="small"
        type="button"
        corner="rounded-edges"
        className={`${namespace}__action-button`}
        icon={chevronDownOutline}
        iconPosition="right"
      >
        <StyledDescText type="body3" weight={500} color="neutral-60">
          {actions}
        </StyledDescText>
      </AllieButton>
      <AlliePopover
        ref={popoverRef}
        mode="ios"
        trigger="btn-actions"
        triggerAction="click"
        alignment="end"
        content={{
          children: (
            <PopoverContent className="ion-content">
              <AllieList>
                <AllieItem onclick={() => handleClickPopover(onClickResume)} detail={false} button>
                  <div style={{ height: 18 }}>
                    <AlliePlayIcon style={{ width: 16, height: 16 }} />
                  </div>
                  <AllieText type="body3" color="neutral-60" weight={500} style={{ marginLeft: 8 }}>
                    {resumeOP}
                  </AllieText>
                </AllieItem>
                <AllieItem onclick={() => handleClickPopover(onClickClose)} detail={false} button>
                  <div style={{ height: 18 }}>
                    <AllieStopCircleIcon style={{ width: 16, height: 16 }} />
                  </div>
                  <AllieText type="body3" color="neutral-60" weight={500} style={{ marginLeft: 8 }}>
                    {closeOP}
                  </AllieText>
                </AllieItem>
                <AllieItem onclick={() => handleClickPopover(onClickStart)} detail={false} button>
                  <div style={{ height: 18 }}>
                    <AlliePlayCircleIcon style={{ width: 16, height: 16 }} />
                  </div>
                  <AllieText type="body3" color="neutral-60" weight={500} style={{ marginLeft: 8 }}>
                    {startOP}
                  </AllieText>
                </AllieItem>
              </AllieList>
            </PopoverContent>
          ),
        }}
      />
    </>
  );
};
